import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import WithoutPointList from '@r1-frontend/ui-react/components/List/WithoutPointList';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { RounderContainer } from '@r1-frontend/ui-react/experimental/containers';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Grid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 0.7fr 1fr;
    align-items: start;
    gap: 32px;
    
    @media (max-width: ${wideBreakpoints.tablet}) {
        grid-template-columns: 1fr;
    }
`;

export const ListItem = styled.li`
    &:not(:last-child) {
        margin-bottom: 8px;
    }
`;

export const MapWrapper = styled(RounderContainer)`
    height: 376px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: 600px;
    }
`;

export const SControlElement = styled(ControlElement)`
    ${FONTS.H3}
`;

export const SWithoutPointList = styled(WithoutPointList)`
    width: 100%;
`;
